import { ApiService } from '@services/api';
import { useFetch } from '@providers/Fetch/useFetch';
import { API_DOMAIN } from '@constants/api';
import {
  IGetProps,
  IGetResponse,
  ICreateCredentialProps,
  IUpdateCredentialProps,
  IDeleteCredentialProps,
} from '@domain/interfaces/dashboard/IntegrationCenter/Gateway/IUpnid';

export class UpnidService {
  private readonly apiService: ApiService;

  constructor(baseURL: string) {
    this.apiService = new ApiService(baseURL);
  }

  public getCredential({ storeAliasId }: IGetProps): IGetResponse {
    const { data, error, mutate, isValidating } = useFetch(
      `/api/v1/users/stores/${storeAliasId}/upnid-credentials`,
      this.apiService,
    );

    const isLoading = !error && !data;

    return {
      upnidCredential: data?.upnid_credential,
      error,
      mutate,
      isLoading,
      isValidating,
    };
  }

  public createCredential({ storeAliasId, data }: ICreateCredentialProps): Promise<any> {
    return this.apiService.post(`/api/v1/users/stores/${storeAliasId}/upnid-credentials`, {
      ...data,
    });
  }

  public updateCredential({ storeAliasId, data }: IUpdateCredentialProps): Promise<any> {
    return this.apiService.put(`/api/v1/users/stores/${storeAliasId}/upnid-credentials`, {
      ...data,
    });
  }

  public deleteCredential({ storeAliasId }: IDeleteCredentialProps): Promise<any> {
    return this.apiService.delete(`/api/v1/users/stores/${storeAliasId}/upnid-credentials`);
  }
}

const upnidService = new UpnidService(API_DOMAIN);

export default upnidService;
